/** Endpoint #18 — queue counters, issues indicator and the Apify banner (§11.2). */

import type { StatusResponse } from '@lw/shared';
import { apiJson } from './client';

/** #18 `GET /api/status` */
export function getStatus(signal?: AbortSignal): Promise<StatusResponse> {
  return apiJson<StatusResponse>('/status', { signal });
}
